import { render } from "./OnlineTestsListNew.vue?vue&type=template&id=63ee9b54"
import script from "./OnlineTestsListNew.vue?vue&type=script&lang=js"
export * from "./OnlineTestsListNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__